import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@design-system-etat/dsfr-react';
import styles from './BoutonPdfTelechargeable.module.scss';

const BoutonPdfTelechargeable = ({ urlFichier, label, titreFichier }) => {
    const downloadFile = () => {
        fetch(urlFichier, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(new Blob([blob]));
                const lien = document.createElement('a');
                lien.href = url;
                lien.setAttribute('download', titreFichier);

                document.body.appendChild(lien);
                lien.click();
                lien.parentNode.removeChild(lien);
            });
    };

    return (
        <div className={styles.bouton}>
            <Button
                type="button"
                icon="fr-fi-file-download-line"
                iconPosition="left"
                variant="primary"
                onClick={downloadFile}
                taille="lg"
            >
                {label}
            </Button>
        </div>
    );
};

BoutonPdfTelechargeable.propTypes = {
    urlFichier: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    titreFichier: PropTypes.string.isRequired,
};

export default BoutonPdfTelechargeable;
